import { createRpc } from '@sail/rpc';
import * as analytics from '../../internal/analytics/analytics.server';
import * as reports from '../../internal/errors/reports.server';
import * as metrics from '../../internal/metrics/metrics.server';
import { NAMESPACE } from '../../internal/rpc/constants';
import encoder from '../../internal/rpc/encoder';
const rpc = createRpc({
    namespace: NAMESPACE,
    methods: {
        analyticsAction: analytics.action,
        analyticsLink: analytics.link,
        analyticsModal: analytics.modal,
        analyticsTrack: analytics.track,
        analyticsViewed: analytics.viewed,
        metricsIncrement: metrics.increment,
        metricsGauge: metrics.gauge,
        metricsSet: metrics.set,
        initReports: reports.initReports,
        report: reports.report
    },
    encoder
});
export default rpc;

//# sourceMappingURL=rpc.js.map